import { render, staticRenderFns } from "./payments-type.vue?vue&type=template&id=546104da&"
import script from "./payments-type.vue?vue&type=script&lang=js&"
export * from "./payments-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports